<template>
  <div style="display: inline-flex">
    <a-tooltip
      v-model="tooltipVisible"
      :placement="placement"
      arrowPointAtCenter
      overlayClassName="global-toolTip share"
      @visibleChange="tooltipVisibleChange"
    >
      <template v-if="!disable" #title>
        <div
          v-if="!shareLoading"
          v-clipboard:copy="shareContentText"
          v-clipboard:success="onCopy"
          v-clipboard:error="onError"
          style="text-align: center; margin-top: 7px; cursor: pointer"
        >
          <img :src="ICON_LINK" alt="复制链接" style="width: 20px" />
          <span style="color: #3e7fff">{{ $t('复制链接') }}</span>
        </div>
        <a-icon v-else style="font-size: 24px; color: #000" type="loading" />
        <div style="text-align: center; margin: 15px 0 7px">
          <img :src="ICON_WENXIN" alt="微信扫一扫" style="width: 20px" />
          <span style="color: #2ba245">{{ $t('微信扫一扫') }}</span>
        </div>
        <a-row type="flex" justify="center" align="middle" style="width: 150px; height: 150px">
          <a-col :span="24" style="text-align: center">
            <a-icon v-if="wechatCodeLoading" type="loading" style="font-size: 40px; color: #ff6600" />
            <img v-else class="qrcode" :src="wxlink" width="150" height="150" />
          </a-col>
        </a-row>
      </template>
      <slot />
      <!-- <a-button style="width:100px;height:35px">分享</a-button> -->
    </a-tooltip>
  </div>
</template>
<script>
// api
import { postTrackShareCreate } from '@/api/track'
import { postWechatShareParam, putUpdateStatus } from '@/api/share'
// utils
import { sleep } from '@/utils/util'
// const
import { ICON_LINK, ICON_WENXIN } from '@/const/image'
import { System } from '@/const/constConfig'
export default {
  props: {
    placement: {
      type: String,
      default: 'bottom',
    },
    // 分享链接由接口生成
    // link: {
    //   type: String,
    //   default: ''
    // },
    // 根据参数生成小程序码
    // wxlink: {
    //   type: String,
    //   default: ''
    // },
    // 禁用
    disable: {
      type: Boolean,
      default: false,
    },
    shareType: {
      type: String,
      default: '',
    },
    shareTargetMemberCode: {
      type: String,
      default: '',
    },
    shareParam: {
      type: String,
      default: '',
    },
    // 小程序额外参数
    wechatReturnParam: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      System,
      messages: '',
      ICON_LINK,
      ICON_WENXIN,
      wechatCodeLoading: true,
      tooltipVisible: false,
      shareLoading: true,
      shareId: '',
      shareContentText: '',
    }
  },
  watch: {
    shareTargetMemberCode: {
      handler(val, oldVal) {
        if (val !== oldVal) {
          this.shareContentText = ''
          this.wxlink = ''
          this.shareLoading = true
          this.wechatCodeLoading = true
        }
      },
      deep: true,
    },
  },
  methods: {
    postTrackShareCreate,
    onCopy(e) {
      this.$message.success(this.$t('复制链接成功'))
      // 更新分享状态
      const shareId = this.shareId
      if (shareId) {
        putUpdateStatus(shareId)
      }
    },
    onError(e) {
      this.$message.error(`${this.$t('复制失败提示')}${e.text}`)
    },
    async shareCopyLink() {
      const param = {
        shareChannel: 'html5',
        shareType: this.shareType === 'memberCardCompanyShare' ? 'memberCardShare' : this.shareType,
        targetMemberCode: this.shareTargetMemberCode,
      }
      if (this.shareParam) {
        param.shareParam = this.shareParam
      }
      const res = await postTrackShareCreate(param)
      if (res.code === 0) {
        this.shareLoading = false
        if (res.data.fullPath) {
          this.shareId = res.data.shareId
          this.shareContentText = res.data.fullPath
        } else {
          this.$message.error(this.$t('分享失败提示'))
        }
      } else {
        this.$message.error(this.$t('分享失败提示'))
      }
    },
    async tooltipVisibleChange(visible) {
      // 没有触发浮层或已经生成,中止生成
      if (!visible) {
        return
      }
      // 生成h5分享链接
      if (!this.shareContentText) {
        this.shareCopyLink()
      }
      // 生成微信小程序code
      if (!this.wxlink) {
        let shareType = this.shareType
        shareType = shareType.replace(shareType[0], shareType[0].toLocaleUpperCase())
        const pagePath = System.ShareWechatPath[shareType]
        if (!pagePath) {
          return this.$message.warning(this.$t('微信小程序码生成错误'))
        }
        const param = {}
        param.shareContent = {
          shareChannel: 'webchat_friend',
          shareType: this.shareType,
          shareParam: this.shareParam,
          targetMemberCode: this.shareTargetMemberCode,
        }
        const returnParam = {
          ...this.wechatReturnParam,
        }
        console.log('shareType', shareType)
        switch (shareType) {
          case 'CompanyVideoShare':
            returnParam.insidePageId = 'video'
            break
          case 'CompanyPhotoAlbumShare':
            returnParam.insidePageId = 'photo'
            break
          case 'CompanyHonorShare':
            returnParam.insidePageId = 'honour'
            break
          case 'CompanyEmployeeShare':
            returnParam.insidePageId = 'card'
            break
          case 'CompanyPartnerShare':
            returnParam.insidePageId = 'partner'
            break
          case 'CompanyPanoramaShare':
            returnParam.unicode = this.shareTargetMemberCode
            returnParam.insidePageId = 'scene'
            break
          case 'CompanyDynamicShare':
            returnParam.unicode = this.shareTargetMemberCode
            returnParam.dynamicId = this.shareParam

            returnParam.insidePageId = 'dynamic'
            break
          case 'MemberCardCompanyShare':
            console.log('MemberCardCompanyShare', param.shareContent.shareType)
            param.shareContent.shareType = 'memberCardShare'
            break
          case 'CompanyThreeDimensionalShare':
            returnParam.unicode = this.shareTargetMemberCode
            returnParam.insidePageId = 'company'
            break
          case 'ExhibitionPicShare':
            returnParam.insidePageId = 'photoLive'
            break
          default:
            break
        }
        if (this.shareParam) {
          if (!returnParam.unicode) {
            returnParam.unicode = this.shareParam
          }

          // 云上展览,线下展览,会议
          if (!returnParam.id) {
            returnParam.id = this.shareParam
          }
        }
        param.returnParam = returnParam
        param.perpetual = 1
        console.log('param', param)
        const res = await postWechatShareParam(param)
        if (res.code === 0) {
          await sleep()
          this.wechatCodeLoading = false
          this.wxlink = `https://api.yzdli.com/applet/wechat/getwxacode?pagePath=${pagePath}&scene=${res.data.encodeContent}`
          // 分享状态修改成功
          if (res.data.shareId) {
            putUpdateStatus(res.data.shareId)
          }
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
